export default "__VITE_ASSET__DX_EB9ju__"